<template lang="pug">
nav.v-main-nav.main-nav(v-if="menu" )
	.main-nav__wrap
		template(v-for="(group, groupIndex) in menu" :key="groupIndex")
			template(v-if="group?.type === 'menu' && group.link" )
				a(:href="group.link?.href")
					v-svg-icon.main-nav__icon(:icon="group.link?.icon")
		ul.main-nav__layout
			template(v-for="(group, groupIndex) in menu" :key="groupIndex")
				li.main-nav__cell(v-for="(item, index) in group.items" :key="index")
					a.main-nav__link(
							:href="item.href"
							tabindex="0"
							:class="{'main-nav__link--open': openMenuId === item.menuId, 'main-nav__link--active': item.current }"
							@mouseenter="mouseenter(item)"
							@mouseleave="mouseleave(item)"
							@mousemove="mousemove(item)"
							@click="itemClick(item, $event)")
						v-svg-icon.main-nav__link-icon(v-if="item.icon" :icon="item.icon")
						.main-nav__link-main(v-if="item.text" :class="item?.className") {{item.text}}
					.main-nav__dd(
							v-if="item.items && item.items.length"
							:class="{'main-nav__dd--open': openMenuId === item.menuId}"
							@mouseenter="mouseenter(item)"
							@mouseleave="mouseleave(item)")
						.container.main-nav__dd-container
							.main-nav__dd-grid.masonry-grid(:ref="el => masonryElements.push(el)")
								template(v-for="itemL2 in item.items")
									.main-nav__dd-cell.masonry-grid__cell.masonry-grid__cell--1-of-4
										.main-nav__dd-list
											.main-nav__dd-list-head.flc
												a.main-nav__dd-list-head-link.h5(:href="itemL2.href" :class="{'main-nav__dd-list-head-link--link': itemL2.href}") {{itemL2.text}}
											.main-nav__dd-list-body.flc
												.main-nav__dd-list-item(v-for="itemL3 in itemL2.items")
													a.main-nav__dd-list-link(:href="itemL3.href") {{itemL3.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from '../scripts/controller/controller.js';
import Masonry from 'masonry-layout';

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			menu: [],
			openMenuId: null,
			openTimeout: null,
			closeTimeout: null,
			touch: controller.touch,
			masonryObjects: [],
			masonryElements: []
		};
	},

	beforeUpdate() {
		this.masonryElements.length = 0;
	},

	created() {
		document.addEventListener('click', this.handleClickOutside);
		document.addEventListener('keydown', this.handleEsc);
	},

	unmounted() {
		document.removeEventListener('click', this.handleClickOutside);
		document.removeEventListener('keydown', this.handleEsc);
		window.removeEventListener('resize', this.handleResize);
	},

	methods: {
		initMasonry() {
			let $self = this;
			let $masonryElems = $self.masonryElements;
			delete $self.masonryObjects;
			$self.masonryObjects = [];
			if ($masonryElems.length) {
				$masonryElems.forEach(function(elem) {
					$self.masonryObjects.push(new Masonry(elem, {
						percentPosition: true
					}));
				});
			}
		},

		dataSet(data) {
			this.menu.push(data);
			this.menu.sort((groupA) => groupA.type && groupA.type === 'catalog' ? -1 : 1);
			this.menu.forEach((group, groupIndex) => {
				group.items.forEach((item, itemIndex) => {
					item.menuId = groupIndex + '-' + itemIndex;
				});
			});
			controller.updateMobileNav(data);
			this.initMasonry();
		},

		mouseenter(item) {
			if (this.touch) {
				return;
			}
			if (this.openMenuId === item.menuId) {
				clearTimeout(this.closeTimeout);
			}
		},

		mouseleave() {
			if (this.touch) {
				return;
			}

			clearTimeout(this.openTimeout);
			this.closeTimeout = setTimeout(() => {
				this.openMenuId = null;
			}, 300);
		},

		mousemove(item) {
			if (this.touch) {
				return;
			}

			clearTimeout(this.openTimeout);
			if (item.items && item.items.length) {
				this.openTimeout = setTimeout(() => {
					clearTimeout(this.closeTimeout);
					this.openMenuId = item.menuId;
				}, 40);
			}
		},

		itemClick(item, e) {

			if (!this.touch) {
				return;
			}
			if (this.openMenuId !== item.menuId && item.items && item.items.length) {
				e.preventDefault();
				this.openMenuId = item.menuId;
			} else {
				this.openMenuId = null;
			}
		},

		handleClickOutside(e) {
			if (!this.$el.contains(e.target)) {
				this.openMenuId = null;
			}
		},

		handleEsc(e) {
			if (e.keyCode === 27 && this.openMenuId) {
				e.stopPropagation();
				this.openMenuId = null;
			}
		},

		handleResize() {
			this.initMasonry();
		}
	}
};
</script>